module.exports = __webpack_public_path__ + "site/img/242.47326001.jpg";